import React from 'react';
import { Icon, icons, IconData } from './Icon';

export interface IconListProps {
  /**
   * Search query to filter icons
   */
  searchQuery?: string;

  /**
   * Size of each icon
   */
  iconSize?: number;

  /**
   * Color of each icon
   */
  iconColor?: string;

  /**
   * Function to handle when an icon is clicked
   */
  onIconClick?: (iconName: string) => void;
}

export const IconList: React.FC<IconListProps> = ({
  searchQuery = '',
  iconSize = 24,
  iconColor = 'currentColor',
  onIconClick,
}) => {
  // Filter icons based on the search query
  const filteredIcons = searchQuery
    ? icons.filter(icon => 
        icon.name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : icons;

  const handleIconClick = (iconName: string) => {
    if (onIconClick) {
      onIconClick(iconName);
    }
  };

  return (
    <div>
      {filteredIcons.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          No icons found matching "{searchQuery}"
        </div>
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
            gap: '20px',
          }}
        >
          {filteredIcons.map((icon: IconData) => (
            <div
              key={icon.name}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '12px',
                border: '1px solid #eee',
                borderRadius: '8px',
                cursor: onIconClick ? 'pointer' : 'default',
                transition: 'all 0.2s ease-in-out',
              }}
              onClick={() => handleIconClick(icon.name)}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = '#f9f9f9';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '50px',
                  marginBottom: '8px',
                }}
              >
                <Icon name={icon.name} size={iconSize} color={iconColor} />
              </div>
              <div
                style={{
                  fontSize: '12px',
                  textAlign: 'center',
                  wordBreak: 'break-word',
                }}
              >
                {icon.name}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
